import React, { FC, memo, useState } from 'react';
import {
  Button,
  Card,
  colors,
  CardContent,
  makeStyles,
  Typography
} from '@material-ui/core';
import { slices, useAppSelector } from 'src/redux';
import { TransactionSummaryDialog } from './TransactionSummaryDialog';
import { Sale } from 'src/types';
import { TextRow } from 'src/views/product/component/TextRow';
import { formatCurrency } from 'src/utils';
const useStyles = makeStyles((theme) => ({
  card: {
    [theme.breakpoints.up('xs')]: {
      '&:nth-of-type(odd)': {
        backgroundColor: 'lightgray'
      },
      '&:nth-of-type(even)': {
        backgroundColor: 'white'
      }
    }
  },
  tableRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 0),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  label: {
    fontWeight: 'bold'
  },
  value: {
    textAlign: 'right'
  }
}));

const { selectors: salesSelectors } = slices.sales;

interface Props {
  hideSensitive?: boolean;
}
const Component: FC<Props> = ({ hideSensitive = false }) => {
  const classes = useStyles();
  const sales = useAppSelector(salesSelectors.selectAllSales);

  const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
  const [salesData, setSaleData] = useState<Sale>();

  const onClickViewTransaction = (sale?: Sale) => {
    setIsOpenDialog(true);
    setSaleData(sale);
  };

  return (
    <>
      {sales?.map((sale, index) => (
        <Card key={index} className={classes.card}>
          <CardContent>
            <TextRow
              label="Date Sold(Customer)"
              value={sale?.date_sold || '---'}
            />
            <TextRow label="Branch" value={sale?.branch || '---'} />
            <TextRow label="Customer" value={sale?.customer_name || '---'} />
            <TextRow label="Order No." value={sale?.order_no || '---'} />
            <TextRow
              label="Transaction No."
              value={sale?.transaction_no || '---'}
            />
            <TextRow
              label="SI No."
              value={sale?.acknowledgement_receipt_no || '---'}
            />

            <TextRow
              label="Total Retail Price"
              component={
                <Typography variant="h5" style={{ color: colors.blue[600] }}>
                  {formatCurrency(sale?.total_retail_price)}
                </Typography>
              }
            />
            {!hideSensitive ? (
              <TextRow
                label="TDP"
                component={
                  <Typography
                    variant="h6"
                    style={{ color: colors.orange[600] }}
                  >
                    {formatCurrency(sale?.total_dealers_price)}
                  </Typography>
                }
              />
            ) : null}
            <TextRow
              label="Amount Paid"
              component={
                <Typography variant="h6" style={{ color: colors.purple[600] }}>
                  {formatCurrency(sale?.amount_paid)}
                </Typography>
              }
            />
            <TextRow
              label="Balance"
              component={
                <Typography variant="h6" style={{ color: colors.red[600] }}>
                  {formatCurrency(sale?.balance)}
                </Typography>
              }
            />
            {!hideSensitive ? (
              <TextRow
                label="Gross"
                component={
                  <Typography variant="h6" style={{ color: colors.green[600] }}>
                    {formatCurrency(sale?.total_gross)}
                  </Typography>
                }
              />
            ) : null}

            {!hideSensitive ? (
              <TextRow
                label="Margin"
                component={
                  <Typography
                    variant="h6"
                    style={{ color: colors.lightGreen[500] }}
                  >
                    {sale?.total_margin_percentage}
                  </Typography>
                }
              />
            ) : null}

            <div className={classes.tableRow}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => onClickViewTransaction(sale)}
              >
                View Transaction Details
              </Button>
            </div>
          </CardContent>
        </Card>
      ))}
      <TransactionSummaryDialog
        data={salesData || {}}
        open={isOpenDialog}
        onClose={() => setIsOpenDialog(false)}
        hideSensitive={hideSensitive}
      />
    </>
  );
};
export const SalesCardListings = memo(Component);
